export default __webpack_public_path__ + "static/media/tz.5ca0246e.svg";